<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="coop_cv_name" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_cv_name')">
                            <b-form-input v-model="formData.name" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

                <b-col cols="12">
                    <ValidationProvider name="coop_cv_file" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_cv_file')">
                            <b-form-file v-model="formData.file" accept=".pdf,.doc,.docx" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

                <b-col cols="12">
                    <b-form-group :label="$t('label')">
                        <b-form-select v-model="formData.tags" :options="tagOptions" multiple />
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-3">
                <b-button variant="primary" :disabled="formLoading" @click="createForm">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import CoopCvService from '@/services/CoopCvService';

    export default {
        components: {
            ValidationProvider,
            ValidationObserver
        },
        data() {
            return {
                formLoading: false,
                formData: {
                    name: '',
                    file: null,
                    tags: []
                },
                tagOptions: [
                    { value: 'tr', text: 'Türkçe' },
                    { value: 'en', text: 'İngilizce' },
                    { value: 'de', text: 'Almanca' },
                    { value: 'fr', text: 'Fransızca' }
                ]
            };
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate();

                if (isValid) {
                    this.formLoading = true;

                    const submitData = new FormData();
                    submitData.append('name', this.formData.name);
                    if (this.formData.file) {
                        submitData.append('file', this.formData.file);
                    }
                    submitData.append('tags', JSON.stringify(this.formData.tags));

                    CoopCvService.store(submitData)
                        .then(response => {
                            this.$toast.success(this.$t(response.data.message) || this.$t('coop_cv_added_success'));
                            this.$emit('actionSuccess', true);
                        })
                        .catch((error) => {
                            if (this.showErrors) {
                                this.showErrors(error, this.$refs.formModalValidate);
                            } else {
                                this.$toast.error(error.message || 'Hata oluştu');
                            }
                        })
                        .finally(() => {
                            this.formLoading = false;
                        });
                }
            }
        }
    };
</script>
